import React, { useState, useEffect } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';

import axios from 'axios';
import moment from 'moment';
import { toast } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert';

const CollaboReserveDetail = (props) => {
  const { match, loginId, apiUrl, pkg, history, imgUrl } = props;
  const [payData, setPayData] = useState([]);
  const [menuData, setMenuData] = useState([]);
  const [code, setCode] = useState('');
  const [confirm, setConfirm] = useState('N');
  const [modalShow, setModalShow] = useState(false);
  const [cancelShow, setCancelShow] = useState(false);

  let orderCode = match.params.orderCode;
  console.log(orderCode, loginId, pkg, 'a');

  const _getData = async () => {
    const result = await axios.post(apiUrl + '/collaboReserveDetail', {
      orderCode: orderCode,
      userid: loginId,
      pkg,
    });

    const intReturn = result.data[0].intReturn;
    const listData = result.data[0].listData;
    const menuData = result.data[0].menuList;

    if (intReturn === 0) {
      setPayData(listData);
      setMenuData(menuData);
      setConfirm(listData[0].chkTicket);

      console.log(menuData);
    } else {
      alert('취소된 예약입니다.');
      history.goBack();
      //alert(intReturn);
    }
  };
  const _change = (e) => {
    setCode(e.target.value);
  };

  const _confirm = async () => {
    if (code === undefined || code === null || code === '') {
      toast.warn('입장 승인코드를 입력해주세요.');
    } else {
      const result = await axios.post(apiUrl + '/collaboReserveEnter', {
        code: code,
        reserveCode: payData[0].reserveCode,
        orderCode: orderCode,
        userid: loginId,
        pkg: pkg,
      });

      const intReturn = result.data[0].intReturn;
      if (intReturn === 0) {
        setConfirm('Y');
        setModalShow(true);
      } else if (intReturn === -2) {
        toast.error('취소되었거나 입장된 예약입니다.');
      } else if (intReturn === -3) {
        toast.error('입장 승인코드가 일치하지 않습니다.');
      } else {
        toast.error('오류가 발생했습니다.');
      }
    }
  };
  const _list = () => {
    history.push('/crlist');
  };

  const _preDel = () => {
    setCancelShow(true);
    // confirmAlert({
    //   title: '취소',
    //   message: '예매내역을 취소하시겠습니까? ',
    //   buttons: [
    //     {
    //       label: '예매취소',
    //       onClick: () => _cancel(),
    //     },

    //     {
    //       label: '닫기',
    //     },
    //   ],
    // });
  };
  const _cancel = async () => {
    const orderCode = payData[0].orderCode;
    const paymentKey = payData[0].paymentKey;
    const result = await axios.post(apiUrl + '/collaboReserveCancel', {
      orderCode: orderCode,
      paymentKey: paymentKey,
      userid: loginId,
      pkg: pkg,
    });

    const intReturn = result.data[0].intReturn;
    if (intReturn === 0) {
      toast.success('성공적으로 예약 결제가 취소되었습니다.');
      _getData();
      setCancelShow(false);
    } else if (intReturn === -100 || intReturn === -200) {
      toast.error('취소중 오류가 발생했습니다.');
    } else if (intReturn === -3) {
      toast.error('예약 1일전 까지만 취소가 가능합니다.');
    } else if (intReturn === -2) {
      toast.error('오류로 인해 취소가 롤백되었습니다.');
    } else if (intReturn === -5) {
      toast.error('취소할 내역이 존재하지 않습니다.');
    } else if (intReturn === -1) {
      toast.error('회원정보에 오류가 있습니다.');
    }
  };
  const CommaFormatted = (str) => {
    //console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = '';
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = ',' + (parseInt(str) % 1000) + '00' + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = ',' + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ',0' + (parseInt(str) % 1000) + Money;
          else Money = ',00' + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  const _closeModal = () => {
    setModalShow(false);
  };
  const _reserve = () => {
    history.push('/cr');
  };
  useEffect(() => {
    if (loginId === null || loginId === undefined || loginId === '') {
      history.push('/login');
    } else {
      _getData();
    }
  }, []);

  if (payData.length <= 0) {
    return <div></div>;
  }

  return (
    <>
      <div id="wrap">
        <a className="prev" onClick={_list} style={{ cursor: 'pointer' }}></a>
        {/* <!-- 컨텐츠영역 --> */}
        <section className="container5 tiket2">
          {/* <!-- 왼쪽 컨텐츠 --> */}
          <div className="bx bx_left">
            {/* <h1>
              <img src={imgUrl + '/img/mediaArt/logo.svg'} alt="" />
            </h1> */}
            <div className="comfirm">
              <div className="icon">
                {payData[0].cancel === false && confirm === 'N' && (
                  <img src={imgUrl + '/img/mediaArt/icon_comfirm.gif'} alt="" />
                )}
                {confirm === 'Y' && (
                  <img
                    src={imgUrl + '/img/mediaArt/icon_comfirm2.gif'}
                    alt=""
                  />
                )}
                {payData[0].cancel === true && (
                  <img
                    src={imgUrl + '/img/mediaArt/icon_comfirm2.gif'}
                    alt=""
                  />
                )}
              </div>
              <div className="txt">
                {payData[0].exhibitionName}
                <br />
                {payData[0].cancel === true && '예약 취소가 완료되었습니다.'}
                {confirm === 'Y' && '예약 입장이 완료되었습니다.'}
                {payData[0].cancel === false &&
                  confirm === 'N' &&
                  '예약 결제가 완료되었습니다.'}
              </div>
            </div>
            <div className="section sec_item">
              <h2>예약 내역</h2>
              <div className="item">
                <div className="thumb">
                  <img
                    src={
                      'https://file.aniplustv.com/TShop/collabo/' +
                      payData[0].colImg
                    }
                    style={{ borderRadius: '10px' }}
                    alt=""
                  />
                </div>
                <ul>
                  <li>
                    <span className="tit">작품명</span>
                    <span className="txt">{payData[0].reserveTitle}</span>
                  </li>
                  <li>
                    <span className="tit">장소</span>
                    <span className="txt">
                      {payData[0].collaboLocationName}
                    </span>
                  </li>
                  <li>
                    <span className="tit">날짜</span>
                    <span className="txt">
                      {moment(
                        payData[0].rdate.toString().substring(0, 4) +
                          '-' +
                          payData[0].rdate.toString().substring(4, 6) +
                          '-' +
                          payData[0].rdate.toString().substring(6, 8)
                      ).format('YYYY.MM.DD(dd)')}
                    </span>
                  </li>
                  <li>
                    <span className="tit">시간</span>
                    <span className="txt">
                      {' '}
                      {payData[0].rtime.toString().substring(0, 2) +
                        ':' +
                        payData[0].rtime.toString().substring(2, 4)}
                    </span>
                  </li>
                  <li>
                    <span className="tit">예약수</span>
                    <span className="txt">{payData[0].rcount}인</span>
                  </li>
                  <li>
                    <span className="tit">결제금액</span>
                    <span className="txt">
                      {CommaFormatted(payData[0].price)}원
                      {/* {payData[0].early === 'Y' ? ' (얼리버드)' : ''} */}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="section sec_item">
              <h2>주문 내역</h2>
              <ul>
                {menuData.map((item) => (
                  <li>
                    <span className="tit">
                      {item.menuGubun === 'L' ? '[한정]' : ''} {item.menuName}
                      <br />
                      <em className="menuComment">{item.menuComment}</em>
                    </span>
                    <span className="txt">
                      {item.menuCount}개 | {CommaFormatted(item.sumPrice)}원
                    </span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="section sec_paycont">
              <h2>결제 내역</h2>
              <ul>
                <li>
                  <span className="tit">결제수단</span>
                  <span className="txt">
                    {payData[0].payType} |{' '}
                    {payData[0].payType === '간편결제'
                      ? payData[0].payName
                      : payData[0].codeName}
                  </span>
                </li>
                <li>
                  <span className="tit">결제일</span>
                  <span className="txt">
                    {moment(new Date(payData[0].regDate)).format(
                      'YYYY.MM.DD HH:mm'
                    )}
                  </span>
                </li>
              </ul>
            </div>
          </div>
          {/* <!-- 오른쪽 컨텐츠 --> */}
          <div className="bx bx_right">
            <div className="section_line">
              <div className="comfirm">
                <div className="icon">
                  {payData[0].cancel === false && confirm === 'N' && (
                    <img
                      src={imgUrl + '/img/mediaArt/icon_comfirm.gif'}
                      alt=""
                    />
                  )}
                  {confirm === 'Y' && (
                    <img
                      src={imgUrl + '/img/mediaArt/icon_comfirm2.gif'}
                      alt=""
                    />
                  )}
                  {payData[0].cancel === true && (
                    <img
                      src={imgUrl + '/img/mediaArt/icon_comfirm2.gif'}
                      alt=""
                    />
                  )}
                </div>

                <div className="txt">
                  {payData[0].exhibitionName}
                  <br />
                  {payData[0].cancel === true && '예약 취소가 완료되었습니다.'}
                  {confirm === 'Y' && '예약 입장이 완료되었습니다.'}
                  {payData[0].cancel === false &&
                    confirm === 'N' &&
                    '예약 결제가 완료되었습니다.'}
                </div>
              </div>
            </div>
            <div className="section section_line">
              {payData[0].cancel === false ? (
                confirm === 'N' ? (
                  <div className="sec_approve">
                    <h2 style={{ color: 'red' }}>
                      예약일 카페 입장시 스태프가 입력하는 곳입니다.
                    </h2>
                    <div className="approve_input">
                      <input
                        type="text"
                        className="input"
                        name="confirmCode"
                        value={code}
                        onChange={_change}
                        maxLength={6}
                      />
                      <a onClick={_confirm} style={{ cursor: 'pointer' }}>
                        입장승인
                      </a>
                    </div>
                  </div>
                ) : (
                  <div className="txt"></div>
                )
              ) : (
                <div className="txt"></div>
              )}
            </div>
            <div className="section section_line sec_item">
              <h2>예약 내역</h2>
              <div className="item">
                <div className="thumb">
                  <img src={payData[0].img} alt="" />
                </div>
                <ul>
                  <li>
                    <span className="tit">콜라보명</span>
                    <span className="txt">{payData[0].reserveTitle}</span>
                  </li>
                  <li>
                    <span className="tit">장소</span>
                    <span className="txt">
                      {payData[0].collaboLocationName}
                    </span>
                  </li>
                  <li>
                    <span className="tit">날짜</span>
                    <span className="txt">
                      {' '}
                      {moment(
                        payData[0].rdate.toString().substring(0, 4) +
                          '-' +
                          payData[0].rdate.toString().substring(4, 6) +
                          '-' +
                          payData[0].rdate.toString().substring(6, 8)
                      ).format('YYYY.MM.DD(dd)')}
                    </span>
                  </li>
                  <li>
                    <span className="tit">시간</span>
                    <span className="txt">
                      {payData[0].rtime.toString().substring(0, 2) +
                        ':' +
                        payData[0].rtime.toString().substring(2, 4)}
                    </span>
                  </li>
                  <li>
                    <span className="tit">예약수</span>
                    <span className="txt">{payData[0].rcount}인</span>
                  </li>
                  <li>
                    <span className="tit">결제금액</span>
                    <span className="txt">
                      {CommaFormatted(payData[0].price)}원
                      {/* {payData[0].early === 'Y' ? ' (얼리버드)' : ''} */}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="section section_line sec_item">
              <h2>주문 내역</h2>
              <ul>
                {menuData.map((item) => (
                  <li>
                    <span className="tit">
                      {item.menuGubun === 'L' ? '[한정]' : ''} {item.menuName}
                      <br />
                      <em className="menuComment">{item.menuComment}</em>
                    </span>
                    <span className="txt">
                      {item.menuCount}개 | {item.sumPrice}원
                    </span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="section section_line sec_paycont">
              <h2>결제 내역</h2>
              <ul>
                <li>
                  <span className="tit">결제수단</span>
                  <span className="txt">
                    {' '}
                    {payData[0].payType} |{' '}
                    {payData[0].payType === '간편결제'
                      ? payData[0].payName
                      : payData[0].codeName}
                  </span>
                </li>
                <li>
                  <span className="tit">결제일</span>
                  <span className="txt">
                    {moment(new Date(payData[0].regDate)).format(
                      'YYYY.MM.DD HH:mm'
                    )}
                  </span>
                </li>
              </ul>
            </div>
            <div className="section">
              <div className="btn_area">
                {payData[0].cancel === false &&
                  payData[0].cancelFlag === 'live' &&
                  confirm === 'N' && (
                    <a
                      onClick={_preDel}
                      style={{ cursor: 'pointer', backgroundColor: 'green' }}
                    >
                      예약취소
                    </a>
                  )}
                {payData[0].cancel === false &&
                  payData[0].cancelFlag === 'expired' &&
                  confirm === 'N' && <a>취소기간 만료</a>}

                {payData[0].cancel === true && <a>취소완료</a>}
                {confirm === 'Y' && <a>입장완료</a>}

                <a onClick={_list} style={{ cursor: 'pointer' }}>
                  나의 예약 목록
                </a>
              </div>
              <div className="btn_area1">
                <a onClick={_reserve}>콜라보 예약하기</a>
              </div>
            </div>
          </div>
        </section>
      </div>
      {modalShow && (
        <>
          <div className="dimmed"></div>
          <div className="modal modal_comfirm">
            <div className="icon">
              <img src={imgUrl + '/img/mediaArt/icon_comfirm2.gif'} alt="" />
            </div>
            <p className="txt">입장승인 완료되었습니다.</p>
            <div className="btn_area">
              <a onClick={_closeModal} style={{ cursor: 'pointer' }}>
                확인
              </a>
            </div>
          </div>
        </>
      )}
      {cancelShow && (
        <>
          <div className="dimmed"></div>
          <div className="modal modal_comfirm">
            <div className="icon">
              <img src={imgUrl + '/img/mediaArt/warning.gif'} alt="" />
            </div>
            <p className="txt">예약을 취소하시겠습니까?</p>
            <div className="btn_area">
              <a onClick={_cancel} style={{ cursor: 'pointer' }}>
                확인
              </a>
              <a
                onClick={() => setCancelShow(false)}
                style={{ cursor: 'pointer' }}
              >
                닫기
              </a>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default shopContext(withRouter(CollaboReserveDetail));
